import { AccountFlagNames } from '@modules/userProfile/account/FeatureFlags';
import { getShellConfig } from '@src/config/shell/config';
import { addDays } from '@superbet-group/web.lib.utilities';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { featureFlagService } from '@superbet-group/web.lib.flags';

const storageKey = 'ftdReminderLastShown';

export function setFtdReminderLastShown() {
    localStorage.setItem(storageKey, new Date().toISOString());
}

export function isFtdReminderShownToday() {
    const lastShown = localStorage.getItem(storageKey);
    if (!lastShown) {
        return false;
    }

    const lastShownDate = new Date(lastShown);
    const today = new Date();

    return lastShownDate.getDate() === today.getDate();
}

export async function shouldShowDepositReminder(rootGetters: any): Promise<boolean> {
    const user = rootGetters['data/authentication/user'];

    if (!user?.registrationDate) {
        return false;
    }

    const isExtendedFtdReminderEnabled = await featureFlagService.getFeatureValue(
        AccountFlagNames.isExtendedFtdReminderEnabled,
        false,
    );

    const registrationDate = new Date(user.registrationDate.getTime());
    const numberOfDaysToShowMessage = 5;
    const lastDay = addDays(numberOfDaysToShowMessage, registrationDate);
    let isExpandedFtdReminder = false;
    if (new Date() > lastDay) {
        if (isExtendedFtdReminderEnabled) {
            // extending FTD reinder period to 15 days
            const extendedNumberOfDaysToShowMessage = 15;
            const extendedLastDay = addDays(extendedNumberOfDaysToShowMessage, registrationDate);
            if (new Date() > extendedLastDay) {
                return false;
            } else {
                isExpandedFtdReminder = true;
            }
        } else {
            // default behavior
            return false;
        }
    }

    const depositConfig = getShellConfig().remoteConfig.wallet.deposit;
    const result = !user.hasMadeDeposit && depositConfig.isFtdReminderEnabled && !isFtdReminderShownToday();
    if (result && isExpandedFtdReminder) {
        // the FTD reminder will be shown, and we are in the expanded FTD reminder period.
        AnalyticsSDK.getInstance().log('Extended_First_Time_Deposit_Shown');
    }
    return result;
}
